const textFieldFormCreateUser = {
  email: 'Email',
  confirmationEmail: 'Confirme el Email',
  helperTextEmail: 'La invitación será enviada a este email.',
  helperTextConfirmationEmail: 'Emails son diferentes'
};

export default textFieldFormCreateUser;
